import { render, staticRenderFns } from "./week-more.vue?vue&type=template&id=25a11fd1&scoped=true&"
import script from "./week-more.vue?vue&type=script&lang=js&"
export * from "./week-more.vue?vue&type=script&lang=js&"
import style0 from "./week-more.vue?vue&type=style&index=0&id=25a11fd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a11fd1",
  null
  
)

export default component.exports